import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { SeoService } from '@core/services/seo.service';
import { YoutubeVideo } from '@generated/graphql';
import { VideoObject, WithContext } from 'schema-dts';

import { JsonLdComponent } from '@features/seo/json-ld/json-ld.component';
import { YoutubePlayerLazyComponent } from '../youtube-player-lazy/youtube-player-lazy.component';

@Component({
    selector: 'app-youtube-player-contentful',
    templateUrl: './youtube-player-contentful.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [YoutubePlayerLazyComponent, JsonLdComponent],
})
export class YoutubePlayerContentfulComponent implements OnInit {
    @Input() entry: YoutubeVideo;

    seoYoutubeVideo: WithContext<VideoObject>;

    videoId: string = '';
    constructor(private seoService: SeoService) {}

    ngOnInit(): void {
        if (this.entry?.videoUrl) {
            const urlTree = new URL(this.entry.videoUrl);
            this.videoId = urlTree.searchParams.get('v');
        }
        this.seoYoutubeVideo = this.seoService.generateYoutubeVideo(this.entry);
    }
}
